module.exports = __webpack_public_path__ + "static/img/loveIcon.cc55259.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/loveIcon.svg
// module id = 326
// module chunks = 0